import {
  createFormDefinition,
  updateFormDefinition,
} from '../../../util/APIUtils';
import { DEFAULT_SAVE_ERROR } from '../constants/form-manage.constants';

const extractErrorFromBody = (body) => {
  if (!body || typeof body !== 'object') {
    return null;
  }
  if (typeof body.error === 'string') {
    return body.error;
  }
  if (typeof body.message === 'string') {
    return body.message;
  }
  return null;
};

const extractErrorFromJsonResponse = async (err) => {
  try {
    const body = await err.json();
    return extractErrorFromBody(body);
  } catch {
    return null;
  }
};

const hasJsonMethod = (err) => err && typeof err.json === 'function';

/**
 * Resolve a user-facing toast message from an error thrown by `APIUtils.request`.
 * @param {unknown} err
 * @returns {Promise<string>}
 */
export const getErrorToastMessage = async (err) => {
  if (hasJsonMethod(err)) {
    const fromBody = await extractErrorFromJsonResponse(err);
    if (fromBody) {
      return fromBody;
    }
  }
  if (typeof err?.message === 'string' && err.message !== '') {
    return err.message;
  }
  return DEFAULT_SAVE_ERROR;
};

/**
 * @param {string} formId
 * @param {{ name: string, isActive: boolean, schema: object }} input
 */
export const updateExistingForm = (formId, { name, isActive, schema }) =>
  updateFormDefinition(formId, {
    name,
    is_active: isActive,
    schema,
  });

/**
 * @param {{ name: string, isActive: boolean, schema: object }} input
 */
export const createNewForm = async ({ name, isActive, schema }) => {
  const created = await createFormDefinition({ name, schema });
  if (!isActive && created?.id) {
    await updateFormDefinition(created.id, { is_active: false });
  }
  return created;
};
